import "../css/card_design.css"
// import Popup from './Popup';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Login from "./login";
import TopBarLogin from './TopBarLogin';
import logo from '../images/logo.jpeg';
import { Oval } from "react-loader-spinner";
import ResetRequest from "../model/request/ResetRequest";
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";


function Changepassword() {

    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;

    const disableRightClick = (e) => {
        e.preventDefault();
    };





    var [Oldpassword, setOldpassword] = useState("");
    var [OldpasswordError, setOldpasswordError] = useState()

    var [Newpassword, setNewpassword] = useState("");
    var [NewpasswordError, setNewpasswordError] = useState()
    // var password = ""
    var [Confirmpassword, setConfirmpassword] = useState("")
    var [ConfirmpasswordError, setConfirmpasswordError] = useState()
    const [isLoading, setIsLoading] = useState(false)
    var location = useLocation();
    var { userId } = location.state || {};


    //   var {login} = location.state || {};
    const navigation = useNavigate()
    // navigation('/login', { state: { login } }) 

    function clicktologinscreen() {


        if (validation()) {
            resetAPICall();
            // navigation('/login',{state:(userId)});

        }

    }
    function validation() {
        var isFlage = true
        {
            if (Oldpassword == "") {
                setOldpasswordError("Please enter your Old password")
                isFlage = false
            }
            else {
                setOldpasswordError("")
            }

            if (Newpassword == "") {
                setNewpasswordError("Please enter your New password")
                isFlage = false
            }
            else {
                setNewpasswordError("")
            }
            if (Confirmpassword == "") {
                setConfirmpasswordError("Please Confirm your password")
                isFlage = false
            }
            else if (Confirmpassword !== Newpassword) {
                setConfirmpasswordError("Passwords do not match")
                isFlage = false
            }
            else {
                setConfirmpasswordError("")
            }
            return isFlage;
        }

    }

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }


    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }


    function resetAPICall() {
        var request = new ResetRequest();
        request.userId = userId;

        request.oldPassword = Oldpassword;
        request.newPassword = Newpassword;
        request.confirmPassword = Confirmpassword;

        console.log("Response:", JSON.stringify(request));
        axios.post(
            ApiConfig.getUrl("User/changePassword"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`

                }
            }
        )
            .then(response => {

                const api = ApiResponse.fromJson(response.data);
                console.log("Response:", api);
                if (api.status == true && api.statusCode == 200) {
                    showToast(api.message);
                    setTimeout(() => {
                        navigation('/login');
                    }, 100);

                } else {
                    showToastFailed(api.errorMessage);
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }

    const handleHomeClick = () => {
        navigation("/Viewpage");
    };

    return (
        <div className='fullview' onContextMenu={disableRightClick}>

            <ToastContainer />
            {isLoading && (
                <div className="loader-overlay">
                    <Oval
                        height={60}
                        width={60}
                        color="#ffffff"
                        secondaryColor="#cccccc"
                        strokeWidth={4}
                        visible={true}
                    />
                </div>
            )}
            <div className='container'>
                <div className="top-bar shadow-sm">
                    <div className='container'>
                        <ul className="d-flex align-items-center mb-0">
                            <img src={logo} alt='logo' style={{ width: '70px', cursor: 'pointer' }} onClick={handleHomeClick} />
                            <li className='ms-auto' style={{ listStyle: 'none', cursor: 'pointer' }} onClick={handleHomeClick}>
                                <i className="bi bi-house me-1"></i>Home
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='row mt-5 align-items-center gx-0'>
                    <div className="col-lg-5 col-12  p-4 d-flex justify-content-center align-items-center mt-3">
                        <img className='image h-100 w-100' src={logo} alt='logo' />
                    </div>
                    <div className="col-lg-6 col-12 card  p-3">
                        <h2 className='title h4'>Change Your Password</h2>



                        <input className="input-style" type="text" placeholder="Old Password" onChange={(e) => setOldpassword(e.target.value)} />
                        <span className='input-error'>{OldpasswordError}</span>
                        <input className="input-style" type="text" placeholder="New Password" onChange={(e) => setNewpassword(e.target.value)} />
                        <span className='input-error'>{NewpasswordError}</span>
                        <input className="input-style" type="text" placeholder="Confirm Password" onChange={(e) => setConfirmpassword(e.target.value)} />
                        <span className='input-error'>{ConfirmpasswordError}</span>

                        <button onClick={clicktologinscreen} type="button" className="btn  w-100 mt-4 text-light" style={{ backgroundColor: "var(--primary-color)", fontWeight: "bold" }}> Submit </button>
                    </div>
                </div>

            </div>


        </div>
    );
}
export default Changepassword;